import { atom } from 'recoil';

export const JourneyExtensionTypeAtom = atom<'create' | 'edit' | ''>({
	key: 'journeyExtensionType',
	default: '',
});
